export default "__VITE_ASSET__DPl9u3S5__"